import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const SuccessBubbleFilledGlyph = /*#__PURE__*/createElement("g", {
  id: "success_1_"
}, /*#__PURE__*/createElement("path", {
  className: "st11",
  d: "M42,16c-14.5,0-26.3,11.8-26.3,26.3c0,12.5,8.7,22.9,20.3,25.6l2.6,2.9l3.5,5.2l5.3-7.8l0.1-0.2 c11.9-2.5,20.8-13.1,20.8-25.7C68.3,27.8,56.5,16,42,16z M56.7,35.1L56.7,35.1L38.9,54.3c-0.4,0.5-1.1,0.7-1.7,0.8h0h0 c-0.6,0-1.2-0.3-1.7-0.7l-8.4-8.6c-0.4-0.4-0.7-1-0.7-1.7c0-0.6,0.3-1.2,0.7-1.6c0.4-0.4,1-0.7,1.7-0.7c0.6,0,1.2,0.3,1.6,0.7 l6.6,6.8l16-17.4c0.9-0.9,2.4-1,3.3-0.1C57.5,32.7,57.5,34.2,56.7,35.1z"
}));
const SuccessBubbleFilled = createSvg({
  name: 'success_bubble_filled',
  path: SuccessBubbleFilledGlyph
});

export default SuccessBubbleFilled;
export { SuccessBubbleFilledGlyph };
